module.exports = __webpack_public_path__ + "static/media/SDTM6-86.217ee5a7.jpg";